<template>
    <div v-if="form">
        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-capitalize text-sm-right">วันที่ :</label>
            <div class="col-sm-8 form-control-plaintext">{{ form.date }}</div>
        </div>

        <template v-if="form.customer">
            <div class="form-group row">
                <label class="col-sm-4 col-form-label text-capitalize text-sm-right">รหัสลูกค้า :</label>
                <div class="col-sm-8 form-control-plaintext">{{ form.customer.customer_id }}</div>
            </div>
            <div class="form-group row">
                <label class="col-sm-4 col-form-label text-capitalize text-sm-right">ชื่อลูกค้า :</label>
                <div class="col-sm-8 form-control-plaintext">{{ form.customer.first_name }} {{ form.customer.last_name }}</div>
            </div>
        </template>

        <template v-if="form.transport_type">
            <div class="form-group row">
                <label class="col-sm-4 col-form-label text-capitalize text-sm-right">ประเภทรถ :</label>
                <div class="col-sm-8 form-control-plaintext">{{ form.transport_type.name }}</div>
            </div>
        </template>

        <template v-if="form.details !== null && form.details.length > 0">
            <div class="form-group row">
                <label class="col-sm-4 col-form-label text-capitalize text-sm-right">สินค้า :</label>
                <div class="col-sm-8 py-0 m-auto table-responsive">
                    <table class="table py-0 my-0 text-left">
                        <tbody>
                            <template v-for="(details, index) in form.details">
                                <tr>
                                    <td class="p-0">
                                        {{ index+1 }}.
                                        <template v-if="details.product">
                                            {{ details.product.sku }}
                                        </template>
                                        <template v-else>-</template>
                                    </td>
                                    <td class="p-0">
                                        <template v-if="details.product">
                                            {{ details.product.name }}
                                        </template>
                                        <template v-else>
                                            <span style="color: red">สินค้านี้ได้ถูกลบออกจากหลังแล้ว</span>
                                        </template>
                                    </td>
                                    <td class="p-0">
                                        {{ details.quantity }} แพ็ค
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>

        <template>
            <div class="form-group row">
                <label class="col-sm-4 col-form-label text-capitalize text-sm-right">หมายเหตุ :</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.note">
                </div>
            </div>
        </template>
        <br>
        <div class="text-center" v-if="form.order_status_id!=2" >
            <button
                    class="btn btn-success mb-3"
                    @click="confirmOrder"
                    style="margin-right: 20px">
                <icon name="check"></icon> บันทึก
            </button>
            <button
                class="btn btn btn-outline-secondary mr-1 mb-3"
                @click="closeModal">
                <icon name="times"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "order-confirm-modal",
    data() {
        return {
            create_date: ""
        };
    },
    computed: {
        ...mapState({
            form: state => {
                return state.Order.orderForm;
            }
        })
    },
    methods: {
        confirmOrder() {
            this.$emit('confirm-order', true)
        },
        closeModal() {
            this.$emit('confirm-order', false)
        }
    }
};
</script>

<style scoped>
</style>
